import React from "react";

import ContentHeader from "components/Layout/ContentHeader";

import "pages/AdminPage.scss";
import "./TourRefundPolicy.scss";

/**
 * 투어 > 환불규정. 신규 투어에 적용되는 공통 초기 기본값(예약금 환불 규정 · 위약금 규정)을 편집하는 화면.
 *
 * BE 는 기본값을 `buccl_main/constants.py`(DEFAULT_DEPOSIT_REFUND_POLICY · DEFAULT_PENALTY_POLICY)에
 * 상수로 두고 있어 조회·수정 API 가 없다. API 가 추가되면 이 화면에 편집 기능을 붙인다.
 * 개별 투어의 규정은 투어 상세(TourEdit) 하단 패널에서 편집한다.
 */
const TourRefundPolicy: React.FC = () => (
  <div className="admin-page">
    <ContentHeader title="환불규정" description="신규 투어에 적용되는 공통 기본 환불 규정을 관리합니다." />

    <div className="admin-page__card">
      <p className="tour-refund-policy__notice">공통 기본 환불 규정 편집 기능은 추가 예정입니다.</p>
    </div>
  </div>
);

export default TourRefundPolicy;
